module.exports = __webpack_public_path__ + "img/final global edu logo.d7c80dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/fair/final global edu logo.jpg
// module id = 359
// module chunks = 1